import type { SsoSiteConfig } from '../types/domain.js';

export interface SsoReturnOptions {
  readonly sso: SsoSiteConfig;
  readonly deploymentStyle?: string | undefined;
  readonly schoolSlug: string;
  readonly userSearch: string;
  readonly field?: string | undefined;
}

export function getReturnURL({
  sso,
  deploymentStyle,
  schoolSlug,
  userSearch,
  field,
}: SsoReturnOptions): string {
  const webDirectUrl =
    deploymentStyle === '多站多域名'
      ? `${schoolSlug}.${window.location.host}/#/home`
      : `${window.location.host}/s/${schoolSlug}/#/home`;
  const adminDirectUrl =
    deploymentStyle === '多站多域名'
      ? `${schoolSlug}.${window.location.host}/admin#/user/login`
      : `${window.location.host}/s/${schoolSlug}/admin#/user/login`;
  const webBaseURL = sso.webRedirectURL ? `${sso.webRedirectURL}/#/home` : webDirectUrl;
  const adminBaseURL = sso.adminRedirectURL
    ? `${sso.adminRedirectURL}/admin#/user/login`
    : adminDirectUrl;
  return field === 'web'
    ? `${window.location.protocol}//${webBaseURL}?${userSearch}`
    : `${window.location.protocol}//${adminBaseURL}?${userSearch}`;
}
